import * as loadjs from 'loadjs';
import { loadCSS as fgCssloader } from 'fg-loadcss';

const setErrorLog = path => {
  console.error(`'${path}' did not load successfully`);
};

// not need to reject in case not script has loaded. the ui know to deal with unloaded scripts
export const loadJs = (path = '', { name }) => {
  return new Promise(resolve => {
    if (!loadjs.isDefined(name)) {
      loadjs([path], name);
    }

    loadjs.ready(name, {
      success: () => resolve({ name, success: true }),
      error: () => {
        setErrorLog(path);
        resolve({ name, success: false });
      }
    });
  });
};

export const loadCss = (path, { name }) => {
  return new Promise(resolve => {
    const head = document.querySelector('head');
    const link = fgCssloader(path, head.children[0]);

    link.onload = () => {
      resolve({ name, success: true });
    };

    link.onerror = () => {
      setErrorLog(path);
      resolve({ name, success: false });
    };
  });
};
